exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-go-course-tsx": () => import("./../../../src/pages/go/course.tsx" /* webpackChunkName: "component---src-pages-go-course-tsx" */),
  "component---src-pages-go-edit-tsx": () => import("./../../../src/pages/go/edit.tsx" /* webpackChunkName: "component---src-pages-go-edit-tsx" */),
  "component---src-pages-go-play-tsx": () => import("./../../../src/pages/go/play.tsx" /* webpackChunkName: "component---src-pages-go-play-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

